export default {
	data() {
		return {
			width: null,
			height: null
		};
	}
};